import { FC } from "react";
import { useParams } from "react-router";
import { FormType } from "./types";

import { VviinnFormsProps } from "./types";
import { ItemRender } from "./render";

import { FormProvider } from "./app/useForm";
import { FormNotificationsProvider } from "./app/useFormNotification";

export const VviinnForms: FC<VviinnFormsProps> = ({
  token,
  formType,
  select,
  filters,
  readonlyColumns,
  companyId,
  id,
  requestType,
  contractId,
  showMainTitle,
  actionId,
  onSuccess,
}) => {
  const {
    formType: formTypeParams,
    companyId: companyIdParams,
    contractId: contractIdParams,
    id: idParams,
  } = useParams();

  const requestFormType = (formType ?? formTypeParams) as FormType;
  const requestCompanyId = companyId ?? companyIdParams;
  const requestContractId = contractId ?? contractIdParams ?? "";
  const requestId = id ?? idParams ?? "";

  return (
    <FormNotificationsProvider>
      <FormProvider
        token={token}
        formType={requestFormType}
        companyId={requestCompanyId}
        contractId={requestContractId}
        id={requestId}
        select={select}
        filters={filters}
        readonlyColumns={readonlyColumns}
        requestType={requestType}
        showMainTitle={showMainTitle}
        actionId={actionId}
        onSuccess={onSuccess}
      >
        <ItemRender showMainTitle={showMainTitle} />
      </FormProvider>
    </FormNotificationsProvider>
  );
};
